// Contact us form submitted
if (window.location.pathname === '/pages/contact') {
  
console.log("zf_ValidateAndSubmit exists?", typeof window.zf_ValidateAndSubmit);
console.log("pagesense object:", window.pagesense);

window.addEventListener("load", function() {
  console.log("Script loaded, zf_ValidateAndSubmit:", typeof window.zf_ValidateAndSubmit);
  
  var originalValidate = window.zf_ValidateAndSubmit;
  window.zf_ValidateAndSubmit = function() {
    console.log("Form submit triggered");
    var result = originalValidate.apply(this, arguments);
    console.log("Validation result:", result);
    if (result) {
      console.log("Firing PageSense event...");
      window.pagesense = window.pagesense || [];
      window.pagesense.push(['trackEvent', 'Contact Form']);
    }
    return result;
  };
});

} 
// New registered users
if (window.location.search.includes('error_description=Please%20verify%20your%20email')) {
  window.pagesense = window.pagesense || [];
  window.pagesense.push(['trackEvent', 'Customer Registration']);
  console.log("Customer Registered!");
}
// Success Checkout
analytics.subscribe("checkout_completed", function(event) {
  window.pagesense = window.pagesense || [];
  window.pagesense.push(['trackEvent', 'Checkout Success']);
});